import React, { Component } from 'react';
import logo from './lk_logo.svg';
import './App.css';
import './css/w3.css';
import './css/w3-theme-black.css';
import {Grid,Container, Image, Menu, Dropdown, Message} from 'semantic-ui-react'
import MorphologyTools from './MorphologyTools';
import SignIn from './SignIn';
import Register from './Register';
import Verify from './Verify';




class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            whichSegmentVisible: "Register"
        };
    }

    functionChangeSegment = (dataFromChild) => {
            this.setState({ whichSegmentVisible: dataFromChild });
        }

    render() {
        var mySegment='';

        switch (this.state.whichSegmentVisible) {
          case "SignIn":   mySegment=<SignIn changeFunction={this.functionChangeSegment}/>; break;
          case "Register":  mySegment=<Register changeFunction={this.functionChangeSegment}/>; break;
          case "Verify":   mySegment=<Verify changeFunction={this.functionChangeSegment}/>; break;
          default:       mySegment=<Register changeFunction={this.functionChangeSegment} />; break;
        }





        return (
            <div className="App">

                <Menu fixed='top' inverted>
                    <Container>
                        <Menu.Item as='a' header>
                            <Image size='mini' src={logo} style={{ marginRight: '1.5em' }} />
                            <span style={{ padding: '0em 0em 0em 0.75em' }}><b>LK - Morphology</b> <i>v1.0</i></span>
                        </Menu.Item>
                        {/*<Menu.Item as='a'>Home</Menu.Item>
                        <Dropdown item simple text='Dropdown'>
                            <Dropdown.Menu>
                                <Dropdown.Item>List Item</Dropdown.Item>
                                <Dropdown.Item>List Item</Dropdown.Item>
                                <Dropdown.Divider />
                                <Dropdown.Header>Header Item</Dropdown.Header>
                                <Dropdown.Item>
                                    <i className='dropdown icon' />
                                    <span className='text'>Submenu</span>
                                    <Dropdown.Menu>
                                        <Dropdown.Item>List Item</Dropdown.Item>
                                        <Dropdown.Item>List Item</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown.Item>
                                <Dropdown.Item>List Item</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>*/}
                        </Container>
                    </Menu>

                <Container style={{ marginTop: '7em' }}>
                    <Grid>
                        <Grid.Column width={16}>
                            <Message color='green'>
                                <Message.Header>This project is developed using Natural Language Processing techniques, React, AWS (S3, Lambda, DynamoDB), beautified using Semantic UI.</Message.Header>
                                <p>Thank you for visiting this page. If you are interested to know more, please contact me at septina[dot]larasati[at]gmail[com]com.<br/>
                                As for now, please enjoy the limited functionalities. Thanks!</p>
                            </Message>
                        </Grid.Column>
                    </Grid>
                    <Grid>
                        <Grid.Column width={16}>
                            <Message color='orange'>
                                <Message.Header>This project is still under construction!</Message.Header>
                            </Message>
                        </Grid.Column>
                    </Grid>


                    {/* <Grid>
                        <Grid.Column width={16}>
                            {mySegment}
                        </Grid.Column>
                    </Grid>*/}
                    <Grid>
                        <Grid.Column width={16}>
                            <MorphologyTools/>
                        </Grid.Column>
                    </Grid>
                </Container>
            </div>


    );
  }


}

export default App;



// WEBPACK FOOTER //
// ./src/App.js